<!--
 * @Author: your name
 * @Date: 2020-02-18 17:12:51
 * @LastEditTime: 2021-05-28 23:55:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Show.vue
 -->
<template>
  <div class="show2" :style="`background: url('${require('../assets/bg15.png')}'); background-size: 100% 100%;`">
  <img class="sub-logo3" src="../assets/logo7.png">
  <img class="sub-logo4" src="../assets/logo8.png">
    <div class="body">
        <div class="content">
            <div class="video" id="video">
                 <img class="sub-logo5" src="../assets/xinchou.png">
                <div class="player_loading">
                    <div class="load-container load8">
                    <div class="loader"></div></div>
                </div>
            </div>
            <p class="seeNum">观看量：{{ seeNum }}人</p>
            <!-- <div class="title">{{ this.info.title }}</div>
            <div class="intro">
             {{ this.info.intro }}
            </div> -->
            <div class="intro">
                <div class="video_border"></div>
                <div class="video_intro">
                    <p class="video_title">
                        <span class="line"></span>
                        <span class="txt">专家简介</span>
                        <span class="line"></span>
                    </p>
                    <p class="video_intro">
                         {{ this.info.intro2 }}
                    </p>
                </div>
                <div class="video_border"></div>
            </div>
        </div>
    </div>

     <div class="footer"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
  </div>
</template>
<script>
import { Http } from "@/utils/http.js"
import api from "@/config/api.js"
import Cookies from 'js-cookie'

export default {
  name: 'List',
  data() {
    return {
        player: '',
        vid: '',
        count: 0,
        uid: '',
        info: {},
        seeVideoId: 0, // 观看页面上报更新的id 值
        browseTime: 1, // 页面浏览时长
        updateTime: 5,  // 页面每次上报的间隔
        browseId: 0, // 浏览页面上报更新的id 值

         interval: '', // 轮询计数
        interval2: '', // 轮询计数
         seeNum : 0, // 观看次数
    }
  },

  methods: {
       // 返回上一页
    goback(){
      this.$router.go(-1)
    },
    // 播放视频
    s2j_onVideoPlay() {
      console.log('视频播放')
      if(this.count == 0){
          this.interval = setInterval(this.upViewTime, 5000)
       }  
      this.count ++;
    },
    // 跟新视频播放时间
    upViewTime(){
        console.log('跟新播放时长---88888')
       var sec4=this.player.j2s_getCurrentTime();
       console.log(sec4)
       console.log('跟新播放时长---77777')
      //return 
       if(this.vid > 0 && sec4 > 0){
          if(this.count > 0){
              if (this.uid) {
                let data = {}
                data.uid = this.uid
                data.vid = this.vid
                data.see_time = sec4
                data.id = this.seeVideoId
                var that = this
                Http.post(api.updateVideoSee, data).then(response => {
                    if (response.code == 1) {
                        if(that.seeVideoId == 0){
                            //首次观看
                            that.seeVideoId = response.id
                        }
                    } 
                })
            }
              
          }
      }
    },
    fininshVideoJs(){
        console.log('视频js 加载完成')
        const polyvPlayer = window.polyvPlayer;
        this.player = polyvPlayer({
          wrap: '#video',
            'width': '100%',
          'height': '0',
          'vid': this.info.src_id
        });
        setInterval(this.upViewTime(),2000);
    },
    loadScript(src, callback){
        var script = document.createElement('script');
        var head = document.getElementsByTagName('head')[0];
        var loaded;
        script.src = src;
        if (typeof callback === 'function') {
            script.onload = script.onreadystatechange = function () {
            if (!loaded && (!script.readyState || /loaded|complete/.test(script.readyState))) {
                script.onload = script.onreadystatechange = null;
                loaded = true;
                callback();
            }
            }
        }
        head.appendChild(script);
    },
    // 获取视频信息
    getVideoInfo () {
        // 视频数据
        let data = {}
        data.id = this.vid
        Http.post(api.getVideoInfoById, data).then(response => {
            if (response.code == 1) {
                // 写入返回的cookie 值
                this.info = response.data
                document.title = response.data.title
                 this.seeNum = response.num
                // 数据存在则调用视频数据
                if(this.info){
                    this.loadScript('http://player.polyv.net/resp/vod-player/latest/player.js',this.fininshVideoJs)
                }
            } 
        })
    },

    // 统计浏览时长
    updateBrowseTime () {
        // 判断用户id 是否存在
        if (this.uid) {
            let data = {}
            data.uid = this.uid
            data.type = 2 // 视频详细页
            data.type_id = this.vid
            data.see_time = this.browseTime
            data.id = this.browseId
            var that = this
            Http.post(api.browseTime, data).then(response => {
                if (response.code == 1) {
                   if(that.browseId == 0){
                       //首次观看
                       that.browseId = response.id
                   }
                } 
            })
            this.browseTime = this.browseTime + 5
        }
    }
  },
  mounted: function() {
    // 获取视频详细
    this.vid = this.$route.query.id
   // this.vid = 1
    this.uid = Cookies.get('uid')
     // 跳转到首页
    if(!this.uid){
        this.$router.push({ name: "Index"})
    }
    // 调用视频
    this.getVideoInfo()
    // 跟新页面停留时间
    this.interval2 = setInterval(this.updateBrowseTime, 5000)
    // 将backToday方法绑定到window下面，提供给外部调用
     window['s2j_onVideoPlay'] = () => {
        this.s2j_onVideoPlay()
     }
  },
  destroyed() {
    //清除轮询
    clearInterval(this.interval);
    clearInterval(this.interval2);
  }

}
</script>

<style lang="less" scoped>
.show2 {
    .sub-logo3 {
    position: absolute;
    width: 160px;
    top: 60px;
    left: 20px;    
}
.sub-logo4 {
    position: absolute;
    width: 30px;
    top: 60px;
    right: 20px;    
}
    display: flex;
    min-height: 100vh;
    flex-direction: column;
     .header {
        min-height: 100px;
        img {
            width: 100%;
            display: block;
        }
    }
    .body {
        flex:1;
        padding-left: 30px;
        padding-right: 30px;
        color: #fff;
        .video {
            margin-top: 120px;
        }
        .sub-logo5 {
            width: 90%;
            margin-left: 5%;
        }
        .title {
            margin-top: 30px;
            margin-bottom: 16px;
            font-size: 16px;
        }
        p {
            margin-block-end: 0px;
            margin-block-start: 0px;
        }
          .seeNum {
                        font-size: 12px;
                        float: right;
                        margin-top: 4px;
                        color: #252222;
                    }
        .intro {
            font-size: 14px;
            margin-top: 32px;
            .video_border {
            border-style:solid;
                border-color: #8fd561;
                width: 80%;
                margin: 0 auto;
            }
            .video_intro {
                background-color: #fff;
                border-radius: 24px;
                color: #2b2828;
                .video_title {
                    font-size: 24px;
                    text-align: center;
                    padding-top: 12px;
                    // padding-bottom: 12px;
                    .line {
                        display: inline-block;
                        width: 80px;
                        border-top: 1px solid #ccc ;
                    }
                    .txt {
                        vertical-align: -4px;
                    }
                }
                .video_intro {
                    font-size: 16px;
                    margin-left: 12px;
                    margin-right: 12px;
                    padding-bottom: 12px;
                    white-space: pre-line;
                }
            }
        }
  }
   .footer {
      position: fixed;
      bottom: 0px;
      right: 0;
      .goback {
        width: 120px
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Show2.vue